<template>
  <div class="items">
    <v-container>
      <v-row>
        <v-col cols="12">
          <!-- List of students -->
          <v-data-table
            :page="page"
            :pageCount="numberOfPages"
            :search="search"
            :loading="loading"
            :headers="headers"
            :items-per-page="itemsPerPage"
            :server-items-length="totalCount"
            :options.sync="options"
            :items="item"
            class="elevation-1 dark--text text-caption px-5 mt-10"
          >
            <!-- Top of table -->
            <template v-slot:top>
              <v-row>
                <v-col cols="6">
                  <!-- Search Box -->
                  <form v-on:submit.prevent="searchItem">
                    <v-text-field
                      v-model="search"
                      placeholder="Search"
                      class="mx-4 dark--text text-body-2 px-5"
                      clearable
                      solo
                      filled
                      dense
                      flat
                      prepend-icon="refresh"
                      append-icon="search"
                      background-color="grey lighten-3"
                      color="dark"
                      @click:append="searchItem"
                      @click:prepend="() => readDataWithLimit(1, itemsPerPage)"
                      @click:clear="readDataWithLimit(1, itemsPerPage)"
                    >
                    </v-text-field>
                  </form>
                </v-col>
                <v-col cols="6" align="right">
                  <v-btn
                    rounded
                    depressed
                    class="primary"
                    link
                    :to="'/item-add'"
                    large
                  >
                    <v-icon>add</v-icon>
                    အသစ်ထည့်ရန်
                  </v-btn>
                </v-col>
              </v-row>
            </template>
            <!-- End of top -->
            <template v-slot:no-data>
              <v-row>
                <v-col cols="12" align="center" class="dark--text my-15">
                  <v-icon>info</v-icon> {{ "no_data" }}
                </v-col>
              </v-row>
            </template>

            <!-- slot for itemname -->
            <template v-slot:[`item.name`]="{ item }">
              <p
                @click="$router.push(`/items/${item._id}`)"
                class="
                  title
                  body-2
                  primary--text
                  font-weight-bold
                  text-decoration-underline
                  name
                "
              >
                {{ item.title }}
              </p>
            </template>
            <!-- slot for points -->
            <!-- slot for userId -->
            <template v-slot:[`item.points`]="{ item }">
              <p class="body-2 title primary--text font-weight-bold name">
                {{ item.points }}
              </p>
            </template>
            <!-- slot for points -->
            <!-- Slot for image -->
            <template v-slot:[`item.photo`]="{ item }">
              <v-img
                :src="item.photo ? item.photo : require('@/assets/LogoSm.jpg')"
                width="60"
                height="60"
                class="my-2"
              ></v-img>
            </template>
            <!-- / Slot for image -->
            <!-- Slot for published -->
            <template v-slot:[`item.published`]="{ item }">
              <v-switch
                v-model="item.published"
              >
              </v-switch>
            </template>
            <!-- /Slot for published -->
            <!-- Slot for delete -->
            <template v-slot:[`item.delete`]="{ item }">
              <v-btn
                small
                icon
                @click="
                  () => {
                    toDelete = item._id;
                    dialog = true;
                  }
                "
                ><v-icon>delete</v-icon></v-btn
              >
            </template>
            <!-- / delete Slot -->
          </v-data-table>
          <confirm-box
            :dialog="dialog"
            @closeDialog="() => (dialog = false)"
            @deleteItem="deleteItem"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import Item from "../../api/model/Item";
import ItemManager from "../../api/model/ItemManager";
import ConfirmBox from "../../components/Util/ConfrimBox.vue";
export default {
  name: "ItemList",
  components: { ConfirmBox },
  data: function () {
    return {
      page: 1,
      totalCount: null,
      numberOfPages: null,
      itemsPerPage: 10,
      loading: false,
      options: {},
      search: null,
      headers: [
        { text: "အမည်", value: "name" },
        { text: "ဓာတ်ပုံ", value: "photo" },
        { text: "Golds", value: "points" },
        { text: "ဖျက်ရန်", value: "delete" },
      ],
      item: [],
      dialog: false,
      toDelete: null,
    };
  },
  methods: {
    readDataWithLimit: async function (page, itemsPerPage) {
      // Table is loading
      this.loading = true;
      try {
        // First get the server item length
        var result = await ItemManager.getTotal(this.token);
        this.totalCount = result;
        console.log(this.totalCount);
        // Calculate skip and limit
        var skip = this.totalCount - itemsPerPage * page;
        var limit;
        if (skip < 0) {
          skip = 0;
          limit = itemsPerPage + skip;
        } else {
          limit = itemsPerPage;
        }

        // Read data with limit
        result = await ItemManager.itemWithRange(skip, limit, this.token);
        this.item = result;
        console.log(this.item);
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log("Error : ", err);
        this.$store.dispatch("MAKE_ERROR", "Cannot fetch item data !");
      }
    },
    searchItem: async function () {
      this.loading = true;
      if (!this.search) {
        // if search text is null reload with default
        this.readDataWithLimit(1, this.itemsPerPage);
      } else {
        try {
          this.item = await ItemManager.searchItem(this.search, this.token);
          this.totalCount = this.item.length;
          this.loading = false;
        } catch (err) {
          this.loading = false;
          console.log("Error : ", err);
          this.$store.dispatch("MAKE_ERROR", "Unable to search !");
        }
      }
    },
    deleteItem: async function () {
      this.dialog = false;
      try {
        await Item.delete(this.toDelete, this.token);
      } catch (error) {
        this.dialog = false;
        console.log("Error:", error);
        this.$store.dispatch("MAKE_ERROR", "Unable to delete");
      }
      this.readDataWithLimit(this.options.page, this.options.itemsPerPage);
    },
    editItem: function (itemId) {
      this.$router.push("/items" + itemId);
    },
  },
  watch: {
    // Do this function everytime the options change
    options: function (options) {
      this.readDataWithLimit(options.page, options.itemsPerPage);
    },
  },

  computed: {
    token: function () {
      return this.$store.state.user.token;
    },
  },
};
</script>
<style scoped>
.name:hover {
  cursor: pointer;
}
</style>